// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh2[data-v-3ca0217c] {\n  text-align: center;\n  color: #42b983;\n}\n#login[data-v-3ca0217c] {\n  height: 100%;\n}\n.login-container[data-v-3ca0217c] {\n  width: 97%;\n  max-width: 500px;\n  padding: 25px;\n  background: #fff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  border: 1px solid #eaeaea;\n  border-radius: 5px;\n  -moz-border-radius: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
